import { Box, Typography } from "@mui/material";
import ReBox from "../../../../../common/ReBox/ReBox";
import LoadingWheel from "../../../../../common/LoadingWheel/LoadingWheel";
import { useTranslation } from "react-i18next";
import CardBase from "../../../components/CardBase/CardBase";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../../common/Context";
import { purple, text } from "../../../../../../theme/colours";
import {
  DriverScoreIcon,
  TeamIcon,
  TrophyIcon,
} from "../../../../../common/Icons";
import PageNav from "../../../../../common/PageNav";

const MyTeams = (props) => {
  const { userGroups } = props;
  const { t } = useTranslation("Dashboard");
  const {
    mobileView,
    tabletView,
    largeView,
    desktopView,
    userRankInfo,
    rankData,
  } = useContext(GlobalContext);

  const [userGroupsSlice, setUserGroupsSlice] = useState([]);
  const [totBubble, setTotBubble] = useState();
  const [currBubble, setCurrBubble] = useState(0);

  const teamsPerPage = desktopView ? 4 : tabletView ? 3 : 2;

  const teamBoxStyle = {
    width: largeView ? "25%" : tabletView ? "49%" : mobileView ? "100%" : "30%",
    height: mobileView ? "18rem" : "100%",
  };
  const teamBoardAreaStyle = {
    width: "100%",
    height: "100%",
    justifyContent: "center",
    padding: "0.5rem 1rem 0",
  };
  const mainTeamStyle = {
    width: "100%",
    height: !desktopView ? "80%" : "87.5%",
    alignItems: "center",
    justifyContent: userGroups.length && userRankInfo ? "flex-start" : "center",
    display: "flex",
    flexDirection: "column",
  };
  const teamTitleStyle = {
    fontSize: "0.875rem",
    fontWeight: 500,
  };
  const teamsDescStyle = {
    lineHeight: 1.25,
    opacity: 0.5,
    mb: "0.875rem",
  };
  const teamTileStyle = {
    padding: "0 0.5rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flex: 1,
    width: "100%",
    mb: "0.875rem",
    boxShadow: "none",
    maxHeight: "3rem",
  };
  const iconContainerStyle = {
    display: "flex",
    alignItems: "center",
    "& svg": {
      width: "28px",
      marginRight: "1rem",
      "& path": {
        fill: text.primary,
      },
      "& rect": {
        fill: "none",
      },
    },
  };
  const rankTextAreaStyle = {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  };
  const trophyIconStyle = {
    fill: purple[1],
    width: "1.25rem",
    marginRight: "0.25rem",
  };
  const altScoreTextStyle = (type) => {
    const rank = {
      fontSize: "1rem",
    };

    const users = {
      fontSize: "0.8rem",
      mt: "0.15rem",
    };

    return {
      fontWeight: 700,
      pl: "0.25rem",
      ...{ rank, users }[type],
    };
  };
  const errorSubTitleStyle = {
    opacity: "50%",
    mt: "0.5rem",
    textAlign: "center",
    width: "350px",
    lineHeight: "1.5",
  };

  const handleBubbleNav = (type) => {
    if (type === "left" && currBubble > 0) {
      setCurrBubble((prev) => prev - 1);
    }
    if (type === "right" && currBubble < totBubble - 1) {
      setCurrBubble((prev) => prev + 1);
    }
  };

  useEffect(() => {
    if (userGroups) {
      let temp = userGroups.length / teamsPerPage;
      setTotBubble(Math.ceil(temp));
    }
    setUserGroupsSlice(userGroups.slice(0, teamsPerPage));
  }, [userGroups]);

  useEffect(() => {
    setUserGroupsSlice(
      userGroups.slice(
        currBubble * teamsPerPage,
        currBubble * teamsPerPage + teamsPerPage,
      ),
    );
  }, [currBubble]);

  return (
    <CardBase
      title={t("teamsHeader")}
      subTitle={t("teamsHeaderDesc")}
      headerColor={purple[3]}
      boxStyle={teamBoxStyle}
      areaStyle={teamBoardAreaStyle}>
      <Box sx={mainTeamStyle}>
        {rankData ? (
          userRankInfo === null ? (
            <>
              <Typography variant="h4">{t("noTeamsT")}</Typography>
              <Typography sx={errorSubTitleStyle}>{t("noTeamsD")}</Typography>
            </>
          ) : (
            <>
              <Typography sx={teamsDescStyle}>{t("teamsDesc")}</Typography>
              {userGroupsSlice.map((team, index) => (
                <ReBox
                  style={teamTileStyle}
                  key={`${team.group.tgId} + ${index}`}>
                  <Box sx={iconContainerStyle}>
                    {team.group.name === "All Users" ? (
                      <DriverScoreIcon />
                    ) : (
                      <TeamIcon />
                    )}
                    <Typography sx={teamTitleStyle}>
                      {team.group.name}
                    </Typography>
                  </Box>
                  <Box sx={rankTextAreaStyle}>
                    <TrophyIcon style={trophyIconStyle} />
                    {team.rank > 0 ? (
                      <Typography
                        sx={altScoreTextStyle("rank")}
                        color={purple[1]}>
                        {"#" + team.rank}
                      </Typography>
                    ) : (
                      <Typography
                        sx={altScoreTextStyle("rank")}
                        color={purple[1]}>
                        {t("notApplicable")}
                      </Typography>
                    )}
                    {team.rank > 0 && (
                      <Typography
                        sx={altScoreTextStyle("users")}
                        color={purple[1]}>
                        {" /" + team.numUsers}
                      </Typography>
                    )}
                  </Box>
                </ReBox>
              ))}
            </>
          )
        ) : (
          <LoadingWheel width={3} />
        )}
      </Box>
      {totBubble ? (
        <PageNav
          handleBubbleNav={handleBubbleNav}
          totBubble={totBubble}
          currBubble={currBubble}
          setCurrBubble={setCurrBubble}
        />
      ) : null}
    </CardBase>
  );
};

export default MyTeams;
